export default class formConfig {
  // 区管单位
  static configList() {
    return [
      {
        title: "项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "prjName",
            type: "slot",
            slotName: "prjName",
            width: "100%",
            disabled: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            }
          },
          {
            label: "招标编号：",
            type: "input",
            value: "tenderReference",
            disabled: true,
          },
          {
            label: "标段号：",
            type: "input",
            value: "section",
            disabled: true,
          },
          {
            label: "招标类别：",
            type: "input",
            value: "tenderClassNumName",
            disabled: true,
          },
          {
            label: "招标内容：",
            type: "input",
            value: "tenderContent",
            disabled: true,
          },
          {
            label: "招标方式：",
            type: "input",
            value: "tenderTypeNumName",
            disabled: true,
          },
          {
            label: "招标监管部门：",
            type: "input",
            value: "regulatorsName",
            disabled: true,
          },
          {
            label: "CA证书类型：",
            value: "oldLockBrand",
            type: "slot",
            slotName: "oldLockBrand",
            width: "100%",
            disabled: true,
          },
          {
            label: "项目负责人（总监）：",
            type: "input",
            value: "personName",
            disabled: true,
          },
          {
            label: "身份证号：",
            type: "input",
            value: "idCard",
            disabled: true,
          },
        ]
      },
      {
        title: "项目负责人要求",
        name: "2",
        icon: "",
        formConfigList: [
          {
            type: "slot",
            class: "formList",
            slotName: "managerList"
          }
        ]
      },
      {
        title: "联合投标单位信息",
        name: "3",
        icon: "",
        formConfigList: [
          {
            type: "slot",
            class: "formList",
            slotName: "unionList"
          }
        ]
      },
      {
        title: "项目负责人/总监变更申请",
        name: "4",
        icon: "",
        tipsList: [
          { text: "（1）请先插入投标项目负责人/总监的数字证书，成功读取信息后，请拔下投标项目负责人/总监的数字证书！" },
          { text: "（2）插入交易人数字证书，点击“保存”，提示“操作成功”后，上传《项目负责人/总监变更申请》扫描件！" },
        ],
        formConfigList: [
          {
            label: "CA数字证书类型：",
            type: "slot",
            value: "regLockBrand",
            slotName: "regLockBrand",
            class: "formBtn",
            width: "100%;"
          },
          {
            label: "投标项目负责人/总监：",
            value: "basicinfoChangeName",
            type: "input",
            disabled: true
          },
          {
            label: "证件类型：",
            value: "idCardTypeName",
            type: "input",
            disabled: true
          },
          {
            label: "证件号码：",
            value: "chageIdCard",
            type: "input",
            disabled: true
          },
        ]
      },
      {
        title: "项目负责人/总监变更申请扫描件",
        name: "5",
        icon: "",
        tipsList: [
          { text: "由投标人填写《项目负责人/总监变更申请》，写明项目负责人/总监的变更理由，并加盖单位公章后，原件彩扫上传。" },
        ],
        formConfigList: [
          {
            label: "变更申请扫描件：",
            type: "slot",
            slotName: "uploadFile",
            width: "100%",
          },
        ]
      },
      {
        title: "状态",
        name: "6",
        icon: "",
        formConfigList: [
          {
            label: "状态：",
            type: "input",
            value: "stateName",
            disabled: true,
          },
          {
            label: "历史审核记录：",
            type: "slot",
            class: "list",
            slotName: "auditBtn",
          },
        ]
      },
    ];
  }
}
